export type PlanTier = {
  numTasks: number;
  pricePerTask: number;
};
export const isTierFree = (tier: PlanTier): boolean => tier.pricePerTask === 0;
